import { ModulesMap, ModulesConfigMap, MockMethodsMap } from '../modulesMaps'

// Declaration of USER module with using MODULES SCHEMA
export default {
	[ModulesConfigMap[ModulesMap.USER].GET_DATA]: {
		mock: true,
		mockMethodName: MockMethodsMap[ModulesMap.USER].GET_CURRENT_USER,
		url: '/path/:id/get-data',
	},
	[ModulesConfigMap[ModulesMap.USER].GET_CACHE_VERSION]: {
		mock: true,
		url: '',
	},
	[ModulesConfigMap[ModulesMap.USER].GET_POPULATION]: {
		url: 'https://datausa.io/api/:path',
	},

	[ModulesConfigMap[ModulesMap.USER].GET_CURRENT_USER]: {
		url: '/users/me/',
	},
	[ModulesConfigMap[ModulesMap.USER].GET_AVAILABLE_COMPANIES]: {
		url: '/companies/',
	},

	[ModulesConfigMap[ModulesMap.USER].GET_PERMISSIONS]: {
		url: '/access/v1/permissions_list/:companyId/', // FIXME: (what??) fix url
	},

	[ModulesConfigMap[ModulesMap.USER].PATCH_USER]: {
		url: '/users/:userId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.USER].PUT_USER]: {
		url: '/users/:userId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.USER].SET_PASSWORD]: {
		url: '/users/set_password/',
		requestOptions: {
			method: 'PATCH',
		},
	},
}
